import { FC } from "react";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MdmActivitySearchHeaderWrapper } from "./MdmActivitySearchHeader.style";
import { searchMdmActivitySiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";

interface ActivitySearchHeaderProps {
  pageId: string;
  onCreateActivity: () => void;
}

export const MdmActivitySearchHeader: FC<ActivitySearchHeaderProps> = ({
  pageId,
  onCreateActivity,
}) => {
  const { pageTitle, fetchLabel } = useSiteCore();

  return (
    <MdmActivitySearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <PermissionWrapper permission={MODULE_PERMISSIONS.ADD_MDM_ACTIVITY}>
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={onCreateActivity}
              className="header-right-button"
              id={`${pageId}-new-button`}
              data-testid={`${pageId}-new-button`}
            >
              {fetchLabel(
                searchMdmActivitySiteCoreKeys.activityHeader,
                searchMdmActivitySiteCoreKeys.createNewActivityButton,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </MdmActivitySearchHeaderWrapper>
  );
};
